'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of security web
 */ const SecurityWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.957",
                y: "31.6211",
                width: "63.9459",
                height: "37.2432",
                rx: "3.51351",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.957 62.1196V65.352C19.957 67.2925 21.5301 68.8655 23.4705 68.8655H80.3895C82.3299 68.8655 83.903 67.2925 83.903 65.352V62.1196H19.957Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1641",
                y: "68.8652",
                width: "19.6757",
                height: "6.04324",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2773",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.53 45.58C58.41 45.58 59.15 46.32 59.15 47.2V53.69C59.15 54.6 58.41 55.31 57.53 55.31H45.62C44.71 55.31 44 54.6 44 53.69V47.2C44 46.32 44.71 45.58 45.62 45.58H46.43V43.14C46.44 40.33 48.73 38 51.58 38C54.43 38 56.72 40.33 56.72 43.14V45.58H57.53ZM54.01 45.58V43.14C54.01 41.82 52.89 40.7 51.57 40.7C50.25 40.7 49.13 41.82 49.13 43.14V45.58H54H54.01Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.SecurityWeb = SecurityWeb;
//# sourceMappingURL=SecurityWeb.cjs.map
